import React from 'react'
import { Navbar, NavDropdown, Nav, Image } from 'react-bootstrap'
import {
    Link
} from "react-router-dom";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import logo from '../img/szelence_ujlogo.png';
import redirect from "../img/redirect.svg";
import { logout } from "../Functions/myfunctions"


function NavbarComp() {
    const isAdmin = (sessionStorage.getItem("role") === "admin");

    return (
        <div>
            <div className='logoutBar'>
                <Row>
                    <Col className='appName'><img src={redirect} alt="redirection icon" width="25px" /> URL Átirányító Központ</Col>
                    <Col className='logout'><Link onClick={logout}><span className="logout-span">x</span> Kijelentkezés </Link></Col>
                </Row>
            </div>
            <Navbar expand="lg" className="custom-navbar" collapseOnSelect  >
                <Navbar.Brand href="/redirections" > <Image src={logo} alt="Logo" id="szelencelogo" /></Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                    <Nav
                        className="mr-auto my-2 my-lg-0 "
                        navbarScroll
                    >
                        <Nav.Link as={Link} eventKey="1" to="/redirections" >Átirányítások</Nav.Link>
                        {(isAdmin)
                            ? <Nav.Link as={Link} eventKey="2" to="/users" >Felhasználók</Nav.Link>
                            : ""
                        }
                        <NavDropdown title="Profil" id="basic-nav-dropdown" focusFirstItemOnShow >
                            <NavDropdown.Item as={Link} eventKey="3" to="/changepassword" >Jelszó módosítás</NavDropdown.Item>
                            <NavDropdown.Item as={Link} eventKey="4" onClick={logout} >Kijelentkezés</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>

                </Navbar.Collapse>
            </Navbar>
        </div>
    )
}

export default NavbarComp;